import React from 'react';
import { Row } from 'react-bootstrap5';

import HappyEmoji from 'images/new_ui/emojis/happy.svg';
import SmileyEmoji from 'images/new_ui/emojis/smiley.svg';
import NeutralEmoji from 'images/new_ui/emojis/neutral.svg';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext } from 'components/Managers/Dashboard/Context';
import useSessionRating from 'components/Managers/Dashboard/Hooks/useSessionRating';
import Rate from './Rate';

export default function SessionFeedback() {
  const { state: { filters } } = useContext();
  const { data: sessionRating, loading } = useSessionRating(filters);

  return (
    <>
      <h5 className="mt-5 mb-4">Session Feedback</h5>

      {loading ? <LoadingPlaceholder className="mb-3" /> : (
        <Row>
          <Rate
            iconSrc={HappyEmoji}
            value={sessionRating['5'].percent}
          />

          <Rate
            iconSrc={SmileyEmoji}
            value={sessionRating['4'].percent}
          />

          <Rate
            iconSrc={NeutralEmoji}
            value={sessionRating['3'].percent}
          />
        </Row>
      )}
    </>
  );
}
